/** Fecha/hora estilo 21/3/2026, 6:04:50 */
export const formatFechaHoraCierre = (fecha) => {
  if (fecha == null || fecha === "") return "";
  const d = new Date(fecha);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleString("es-CO", {
    day: "numeric",
    month: "numeric",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });
};

/** Números sin símbolo de moneda, separador miles es-CO */
export const formatNumeroCierre = (valor) => {
  const n = Number(valor ?? 0);
  if (Number.isNaN(n)) return "";
  return new Intl.NumberFormat("es-CO", {
    maximumFractionDigits: 0,
  }).format(n);
};
